export const MY_TOUR_DISABLED_MESSAGE = "My Tour is temporarily disabled. Please check back soon."

export function showMyTourDisabledNotice(event) {
  event?.preventDefault()
  event?.stopPropagation()
  window.alert(MY_TOUR_DISABLED_MESSAGE)
}
